var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRefreshIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.7083 5.29167C13.35 3.93334 11.425 3.15 9.30831 3.36667C6.24998 3.675 3.73331 6.15834 3.39164 9.21667C2.93331 13.2583 6.05831 16.6667 9.99998 16.6667C12.6583 16.6667 14.9416 15.1083 16.0083 12.8667C16.275 12.3083 15.875 11.6667 15.2583 11.6667C14.95 11.6667 14.6583 11.8333 14.525 12.1083C13.5833 14.1333 11.325 15.4167 8.85831 14.8667C7.00831 14.4583 5.51664 12.95 5.12498 11.1C4.42498 7.86667 6.88331 5 9.99998 5C11.3833 5 12.6166 5.575 13.5166 6.48334L12.2583 7.74167C11.7333 8.26667 12.1 9.16667 12.8416 9.16667H15.8333C16.2916 9.16667 16.6666 8.79167 16.6666 8.33334V5.34167C16.6666 4.6 15.7666 4.225 15.2416 4.75L14.7083 5.29167Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRefreshIcon);
export default __webpack_public_path__ + "static/media/RefreshIcon.95bfd6eab33d76cb1c64c7afe0f92422.svg";
export { ForwardRef as ReactComponent };